import React from 'react';
import '../styling/FollowersGame.css';
import FollowersGameRound from './followers_game/FollowersGameRound';
import FollowersGameOption from './followers_game/FollowersGameOption';

class FollowersGame extends React.Component{
	constructor(props) {
		super(props)
	}


	// state = {
	// 	roundsLeft: 5,
	// 	rounds: this.props.rounds,
	// 	currentRound: {} 
	// }

	// startRound = () => {
	// 	var roundsLeft = [...this.state.rounds];

	// 	var nextRound = roundsLeft.pop();
	// 	this.setState({...this.state, currentRound: nextRound, roundsLeft: roundsLeft.length, rounds: roundsLeft})
	// }

	componentDidMount = () => {
		// this.startRound();
	}	

    render(){
        return(
            <div className="FollowersGame">
            <h1 className="game-title">#WhoHasMoreFollowers?</h1>
                <div className="followers-container">
					<FollowersGameOption handle="ElonMusk" name ="Elon Musk"></FollowersGameOption>
					<FollowersGameOption handle="BarackObama" name="Barack Obama"></FollowersGameOption>
                </div>
            </div>
        );
    }


}




export default FollowersGame;